import { Map } from 'immutable'

export const INITIAL_STATE = Map({
  deleteMission: {},
  deleteMissionIsLoading: false,
  deleteMissionErrorMessage: null,
})
